// engines.js — boot-time coordination seam for the Tier-1 engines.
// Purpose: the app shell is intentionally decoupled from the five engines (built by
// sibling passes into src/api, src/entity, src/realtime, src/reports). In the shipped
// wiring each engine SELF-REGISTERS:
//   - auth core (`user`, `mfa-store`) is registered by src/store/index.js at import
//     time (see src/store/modules/*), and the request layer reads the store/router
//     through src/api/context.js;
//   - the realtime `states`/`trackers`, `report-view`, and `entity-form` modules are
//     registered per-screen by their views on mount (Pattern C).
// So installEngines() is the single boot-time HOOK for anything app-wide that a
// future engine cannot self-register (e.g. the `paasUser` white-label store). It also
// asserts the auth backbone is present so a mis-wire surfaces as one clear warning
// instead of a cascade of "unknown action type: user/auth" at first login.
// Reconstructed from lacak.io deployed behavior; app-specific contract verbatim
// (module names `user`/`paasUser` — AUTH-SESSION §7), internal impl re-authored.

/**
 * @param {import('vuex').Store} store
 * @returns {Promise<import('vuex').Store>}
 */
export async function installEngines(store) {
  const hasUser = typeof store.hasModule === 'function' && store.hasModule('user')
  if (!hasUser) {
    // eslint-disable-next-line no-console
    console.warn(
      '[tracko] auth core (`user` module) is not registered. Expected from ' +
        'src/store/index.js (src/store/modules/user.js) or the src/api engine. ' +
        'Login and the session guard will not function until it is wired.'
    )
  }
  return store
}

export default installEngines
